import angular from 'angular';

class VideoplayerController {
  constructor($rootScope, $scope, $state, $sce, $stateParams, $timeout, $interval, analyticsService, laboxSSapi, storage) {
    this.name = 'videoplayer';
    this.API = null;
    this.$scope = $scope;
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.$timeout = $timeout;
    this.$interval = $interval;
    this.$rootScope = $rootScope;
    this.playPause = true;
    this.currentPlayerState = 'Stop';
    this.timer = 0;
    this.videoerror = false;
    this.controls = document.getElementById('controls-animation');

    this.$timeout(() => {
      this.title = this.$rootScope.title;
      console.log("title is :: " +this.title);
    },150);

    this.timer = this.$timeout(() => {
      this.controls.className = 'hide-animation';
    },5000);

    if (this.$rootScope.fromLandingPage == true) {
      this.config = {
        sources: [
          {
            src: $sce.trustAsResourceUrl(this.$stateParams.url),
            type: 'video/webm'
          }
        ],
        theme: {
          url: '../../../assets/videogular.css'
        },
        autoPlay: true,
        playsInline: false
      };
    } else {
      this.config = {
        sources: [
          {
            src: $sce.trustAsResourceUrl(this.$stateParams.url),
            type: 'video/mp4'
          }
        ],
        theme: {
          url: '../../../assets/videogular.css'
        },
        autoPlay: true,
        playsInline: false
      };
    }
    
    if (this.$rootScope.fromLandingPage == true) {
      if (storage.getItem('session','home_id') == "40520101") {
        console.log('specific case where it should play the default video and get the api response');
      } else if (storage.getItem('session','home_id') == "36063655") {
        this.$rootScope.fromVideoBillPage = true;
            this.$rootScope.fromLandingPage = false;
            this.$state.go('home.landingpage');
      } else if (storage.getItem('session','home_id') == "36071973") {
        console.log('specific case where it should play the default video and get the api response');
      } else if (storage.getItem('session','home_id') == "65489856") {
        console.log('specific case where it should play the default video and get the api response');
      } else {
        laboxSSapi.getVideoBill().then((res)=>{
          if(res && res.data._links){
            this.working_link = res.data._links['video-stream'][0].href;
            if (this.working_link != null) {
              console.log('in video player video bill works and you came from landing page');
            } else {
              console.log('in video player video bill works but it has no link');
              // this.$rootScope.fromVideoBillPage = true;
              // this.$rootScope.fromLandingPage = false;
              // this.$state.go('home.landingpage');
            }
          } else {
            console.log('no response from videobill');
            this.$rootScope.fromVideoBillPage = true;
            this.$rootScope.fromLandingPage = false;
            this.$state.go('home.landingpage');
          }
        });
      }
    } else {
      console.log('you are not from video bill');
    }

    // this.timer = this.$timeout(() => {
    //   this.controls.className = 'hide-animation';
    // },5000);

    this.onPlayerReady = API => {
      this.API = API;
      this.API.playsInline = true;
      
      this.$timeout(() => {
       // omniture when video playing
        console.log('!!omniture when video playing!!');
        analyticsService.sendReport('tutorials', 'vod play', null, null, this.title, null, null, null,
          this.$rootScope.omnitureBillingStatus, this.$rootScope.omniturePaperlessbill);
      },150);

    };

    this.alertDone = _ => {
      this.videoerror = false;
      this.$timeout(() => {
        window.removeEventListener('keydown', this.keydown);
        if (this.$rootScope.fromLandingPage == true) {
          this.$rootScope.fromVideoBillPage = true;
          this.$rootScope.fromLandingPage = false;
          this.$state.go('home.landingpage');
        } else {
          //set up conditional to differentiate between tutorials and video bill
          this.$rootScope.fromTutorialPage = true;
          this.$state.go('home.tutorials');
        }
      }, 150);
    };

    this.keyWatch = (event) => {
      window.addEventListener('keydown', this.keydown,false);
    };

    this.$scope.$on('$destroy', () => {
      this.$interval.cancel(this.promise);
    });

    this.scrubSpeed = 0;

    this.keydown = (event)=> {
      if (event.keyCode !== 27 && event.keyCode !== 8 && event.keyCode !== 461 && event.keyCode !== 463 && event.keyCode !== 80 &&
       event.keyCode !== 417 && event.keyCode !== 70 && event.keyCode !== 412 && event.keyCode !== 82) {
        return;
      }

      if (angular.isDefined(this.promise)) {
        this.$interval.cancel(this.promise);
      }
      // you clicked back
      if(event.keyCode === 27 || event.keyCode === 8 || event.keyCode === 461){
        window.removeEventListener('keydown', this.keydown);
        console.log("you clicked!");
        if (this.$rootScope.fromLandingPage == true) {
          this.$rootScope.fromVideoBillPage = true;
          this.$rootScope.fromLandingPage = false;
          this.$state.go('home.landingpage');
        } else {
          //set up conditional to differentiate between tutorials and video bill
          this.$rootScope.fromTutorialPage = true;
          this.$state.go('home.tutorials');
        }

        // you clicked pause
      } else if (event.keyCode === 463 || event.keyCode === 80) {
        console.log('you clicked play or pause!');
        this.playPause = true;
        this.scrubSpeed = 0;
        this.controls.className = 'show-animation';
        $timeout.cancel(this.timer);
        if(this.action === true) {
          this.API.play();
          this.action = false;
        } else {
          this.API.playPause();
        }
        this.timer = this.$timeout(() => {
          this.controls.className = 'hide-animation';
        },5000);
      } else if (event.keyCode === 417 || event.keyCode === 70) {
        console.log('you clicked fast forward!');
        $timeout.cancel(this.timer);
        this.controls.className = 'show-animation';
        this.action = true;
        this.scrubSpeed = this.scrubSpeed < 0 ? 0 : this.scrubSpeed;

        if (this.scrubSpeed < 2) {
          this.scrubSpeed++;
          this.playPause = false;
          $scope.ffImage = "assets/video_player/FF"+this.scrubSpeed+".png";
        }
        this.promise = this.$interval(() => {
          this.seekRepeat('forward', this.scrubspeed);
        }, 100);
        this.API.play();
        // you clicked fast rewind
      } else if (event.keyCode === 412 || event.keyCode === 82) {
        $timeout.cancel(this.timer);
        this.controls.className = 'show-animation';
        this.API.play();
        console.log('you clicked fast rewind!');
        this.action = true;
        this.scrubSpeed = this.scrubSpeed > 0 ? 0 : this.scrubSpeed;


        if (this.scrubSpeed > -2) {
          this.scrubSpeed--;
          this.playPause = false;
          $scope.ffImage = "assets/video_player/RR"+Math.abs(this.scrubSpeed)+".png";
        }
        this.promise = this.$interval(() => {
          this.seekRepeat('rewind', this.scrubspeed);
        }, 100);
        // this.controls.className = 'show-animation';
        // this.timer = this.$timeout(() => {
        //     this.controls.className = 'hide-animation';
        //   },5000);
      }
    };

    $scope.$on('videogularStateChange', (event, state) => {
      if (state === 'play' || state === 'pause') {
        this.scrubSpeed = 0;
      }
    });

  }
  onError() {
    this.videoerror = true;
    this.$timeout(() => {
      this.focusItem('alert-confirm-btn');
      // // document.getElementById('alert-confirm-btn').focus();
    }, 150);
    // // this.$state.go('home.tutorials');
  }

  focus(id){
    console.log("id in focus:", id);
    setTimeout(function() {
      document.getElementById(id).focus();
    }, 150);
  }

  focusItem(id) {
    const el = document.getElementById(id);
    if (el) {
      setTimeout(function() {
        el.focus();
      }, 150);
      // el.focus();
    } else {
      this.$timeout(this.focusItem.bind(this,id));
    }
  }

playback() {
    if (this.$rootScope.fromLandingPage == true) {
      this.$rootScope.fromVideoBillPage = true;
      this.$rootScope.fromLandingPage = false;
      this.$state.go('home.landingpage');
    } else {
      // set up conditional to differentiate between tutorials and video bill
      this.API.stop();
      this.$rootScope.fromTutorialPage = true;
      this.$state.go('home.tutorials');
    }
  }
  seekRepeat(option, scroll) {
    const totalTime = this.API.totalTime / 1000;
    // const totalTime = 127.00000000002;
    const currentTime = this.API.currentTime / 1000;
    console.log('current time is ' + currentTime);
    const frameTime = (totalTime / 1000) * 3 * Math.abs(this.scrubSpeed);
    console.log('frameTime is ' + frameTime + 'and scrubspeed is ' + Math.abs(this.scrubSpeed));

    if (option === 'forward') {
      if (totalTime >= (currentTime + frameTime)) {
        const scrollSpeed = scroll ? 1 : 2;
        this.API.seekTime(currentTime + frameTime);
        console.log('currentTime + frameTime is ' + currentTime + frameTime);
      } else {
        this.API.seekTime(totalTime);
        this.$interval.cancel(this.promise);
        window.removeEventListener('keydown', this.keydown);
        if (this.$rootScope.fromLandingPage == true) {
          this.$rootScope.fromVideoBillPage = true;
          this.$rootScope.fromLandingPage = false;
          this.$state.go('home.landingpage');
        } else {
          //set up conditional to differentiate between tutorials and video bill
          this.API.stop();
          this.$state.go('home.tutorials');
        }
      }
    } else if (option === 'rewind') {
      if ((currentTime - 3) > 0) {
        const scrollSpeed = scroll ? 1 : -2;
        this.API.seekTime(currentTime - frameTime);
      } else {
        this.$interval.cancel(this.promise);
        this.API.stop();
        this.API.setPlayback(1);
        this.API.seekTime(0);
        this.scrubSpeed = 0;
        this.playPause = true;
        this.$timeout(() => {
          this.controls.className = 'show-animation';
          this.API.play();
          this.timer = this.$timeout(() => {
            this.controls.className = 'hide-animation';
          },5000);
        },50);
      }
    }
  }
}


VideoplayerController.$inject = [
  '$rootScope',
  '$scope',
  '$state',
  '$sce',
  '$stateParams',
  '$timeout',
  '$interval',
  'analyticsService',
  'laboxSSapi',
  'storage'
];

export default VideoplayerController;


// WEBPACK FOOTER //
// ./client/app/components/videoplayer/videoplayer.controller.js